import React from 'react'
import { BaseSchema } from '../../../Schema/BaseSchema'
import { LabContactPicker } from '../../../App/LabContacts/Components/LabContactPicker'

interface SchemaLabContactPickerProps {
  className?: any
  schema: BaseSchema
  label?: string
  field?: string
  helperText?: string
  onChange: Function
  disabled?: boolean
  required?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  freeSolo?: boolean
  noOptionsText?: string
  clearOnBlur?: boolean
  enableCreate?: boolean
  labId?: string
}

export const SchemaLabContactPicker: React.FC<SchemaLabContactPickerProps> = ({
  className,
  schema,
  field = 'labContactId',
  label = 'Lab Contact',
  helperText,
  onChange = (value: string, field: string) => {},
  disabled,
  required,
  variant,
  placeholder = 'Select a Lab Contact',
  freeSolo,
  noOptionsText,
  clearOnBlur,
  enableCreate,
  labId,
}) => {
  return (
    <LabContactPicker
      className={className}
      label={label}
      onChange={value => onChange(value, field)}
      disabled={disabled}
      required={required}
      variant={variant}
      placeholder={placeholder}
      freeSolo={freeSolo}
      noOptionsText={noOptionsText}
      clearOnBlur={clearOnBlur}
      enableCreate={enableCreate}
      error={schema.isPropertyInvalid(field)}
      helperText={schema.isPropertyInvalid(field) ? schema.getPropertyError(field) : helperText }
      value={schema.getValue(field) || null}
      labId={labId}
    />
  )
}
